import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { usersSlice } from "../app/modules/Users/_redux/users/usersSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  users: usersSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
